const NS = 'WeekOrderFilter';

export default function WeekOrderFilter($filter) {
  "ngInject";

  return days => {
    days = $filter('orderBy')(days, 'dayNum');
    if (days) {
      days.forEach(day => {
        day.order = day.dayNum;
        if (day.dayNum === 0) {
          day.order = 8;
        }
      });
      days = $filter('orderBy')(days, 'order');
    }

    return days;
  };
}
